import { render, staticRenderFns } from "./PlgBrandItem.vue?vue&type=template&id=77382b42&scoped=true&"
import script from "./PlgBrandItem.vue?vue&type=script&lang=ts&"
export * from "./PlgBrandItem.vue?vue&type=script&lang=ts&"
import style0 from "./PlgBrandItem.vue?vue&type=style&index=0&id=77382b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77382b42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77382b42')) {
      api.createRecord('77382b42', component.options)
    } else {
      api.reload('77382b42', component.options)
    }
    module.hot.accept("./PlgBrandItem.vue?vue&type=template&id=77382b42&scoped=true&", function () {
      api.rerender('77382b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/PlgBrandItem.vue"
export default component.exports